/* nt-storefront.js — light behavior for the generic v21 pages. Portable, no deps. */
(function () {
  /* Reveal on scroll */
  var els = document.querySelectorAll('.nt-store .nt-reveal');
  if (els.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Sort / filter selects that auto-submit their form */
  document.querySelectorAll('.nt-store [data-auto-submit]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (sel.form) sel.form.submit();
      else if (sel.dataset.url) window.location.href = sel.value;
    });
  });

  /* Cart quantity steppers (submit the cart form on change) */
  document.querySelectorAll('.nt-store .nt-qty').forEach(function (q) {
    var input = q.querySelector('input');
    if (!input) return;
    q.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        v = btn.dataset.step === 'up' ? v + 1 : Math.max(0, v - 1);
        input.value = v;
        if (input.form) input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
      });
    });
  });
})();

/* ===== Article table of contents (built from h2/h3; Shopify doesn't id headings) ===== */
(function () {
  var toc = document.querySelector('.nt-store [data-toc]');
  var content = document.querySelector('.nt-store [data-toc-content]');
  if (!toc || !content) return;
  var list = toc.querySelector('.nt-toc__list');
  var headings = content.querySelectorAll('h2, h3');
  if (!list || headings.length < 2) return; // not worth a TOC

  var used = {};
  var slug = function (t) {
    var base = (t || 'section').toLowerCase().trim()
      .replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') || 'section';
    used[base] = (used[base] || 0) + 1;
    return used[base] > 1 ? base + '-' + used[base] : base;
  };

  var links = [];
  headings.forEach(function (h) {
    if (!h.id) h.id = slug(h.textContent);
    var li = document.createElement('li');
    if (h.tagName === 'H3') li.className = 'nt-toc__h3';
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + h.id);
    });
    li.appendChild(a);
    list.appendChild(li);
    links.push(a);
  });
  toc.hidden = false;

  /* Scrollspy: highlight the heading currently in view */
  if ('IntersectionObserver' in window) {
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var visible = new Set();
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) visible.add(en.target.id); else visible.delete(en.target.id);
      });
      var firstActive = null;
      headings.forEach(function (h) { if (!firstActive && visible.has(h.id)) firstActive = h.id; });
      links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href').slice(1) === firstActive); });
    }, { rootMargin: '-20% 0px -70% 0px' });
    headings.forEach(function (h) { spy.observe(h); });
  }
})();
